/**
 * 도움말 셸의 열 치수 — **헤더와 본문이 같은 값을 봐야 한다.**
 *
 * 예전엔 사이드바 폭이 `DocsLayoutView` 에만 하드코딩돼 있어서, 헤더는 자기
 * 사이드바가 얼마나 넓은지 몰랐다. 그 상태로 헤더 검색창을 `mx-auto` 로 두면
 * 뷰포트 기준 가운데에 서고, 본문 열 경계와는 아무 관계가 없다.
 *
 * ── 좌측 존 폭 계산 ─────────────────────────────────────────
 * 헤더 바에는 좌우 `gutter`(14px)가 들어가고 사이드바 열은 x=0 에서 시작한다.
 * 그래서 `헤더 좌측 존 = 사이드바 폭 − gutter` 여야 `center` 가 본문 열의
 * 왼쪽 경계에서 정확히 시작한다. (16.625rem − 14px = 15.75rem)
 *
 * ⚠️ Tailwind 는 조합해서 만든 클래스명을 스캔하지 못한다. 값이 아니라
 *    **완성된 클래스 문자열**을 내보내는 이유다(`APP_HEADER` 와 같은 규약).
 */
export const DOCS_SHELL = {
  /** 사이드바 열 + 본문 열. */
  grid: 'lg:grid-cols-[16.625rem_minmax(0,1fr)]',
  /** 헤더 좌측 존. 사이드바 폭 − 헤더 gutter. */
  headerStart: 'lg:w-[15.75rem]',
} as const;
